<div class="map-create-event">
    <div *ngIf="!map && loading; else divInfoEvent"
        class="loading-container-panel h-100 w-100 d-flex justify-content-center">
        <div class="container-lottie">
            <ng-lottie class="lottie" [options]="{path: 'assets/lotties/loading.json'}"
                containerClass="loading-box"></ng-lottie>
        </div>
    </div>
    <ng-template #divInfoEvent>
        <div class="conteiner-map-event container-in-page">
            <div>
                <!-- Aforo -->
                <div style="margin-bottom: 30px;" *ngIf="!openedCreateMap && !useMapVenue">
                    <div class="capacity-input-wrapper">
                        <p class="capacity-input-label">Aforo del evento <span *ngIf="!external" class="required-field">*</span></p>
                        <div class="capacity-input-container">
                            <i class="fal fa-users capacity-input-icon"></i>
                            <input type="number" class="capacity-input" placeholder="Indica el aforo del evento"
                                [(ngModel)]="capacity" [max]="max" (ngModelChange)="changeCapacity()" name="link" [readOnly]="map && useMapVenue">
                        </div>
                    </div>
                </div>
                <!-- Mapa de butacas -->
                <!-- Solo mostrar si el evento tiene un espacio con mapa de butacas -->
                <div *ngIf="venue && map && useMapVenue" class="map-badge-row">
                    <div class="map-info-row">
                        <i class="fal fa-chart-tree-map"></i>
                        <span>Mapa de butacas: <strong>{{venue?.name}}</strong></span>
                        <button class="map-preview-btn" (click)="toggleMap()">
                            <i class="fal" [class.fa-eye]="!showMap" [class.fa-eye-slash]="showMap"></i>
                            {{ showMap ? 'Ocultar' : 'Ver mapa' }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-map-venue" *ngIf="map && useMapVenue && showMap">
            <!-- Selección de sesión (solo al editar un evento con varias sesiones) -->
            <div class="select-sessions-map mb-3" *ngIf="idEvent && sessionsList?.length > 1">
                <p class="select-session-label mb-0">Seleccionar sesión</p>
                <div class="container-filters">
                    <mat-form-field appearance="fill" class="select-filter-panel mat-select-session">
                        <mat-select class="text-black" panelClass="selectPanelControl"
                            placeholder="Seleccionar sesión" [(ngModel)]="selectedSession"
                            (ngModelChange)="changeSession()" disableOptionCentering="false">
                            <mat-option *ngFor="let session of sessionsList" [value]="session.id">
                                <span>{{getSessionDateString(session)}}</span>
                            </mat-option>
                        </mat-select>
                        <mat-select-trigger matSuffix style="vertical-align: middle;">
                            <i class="fal fa-angle-down pointer-in"></i>
                        </mat-select-trigger>
                    </mat-form-field>
                </div>
            </div>
            <div class="info-default" *ngIf="idEvent">
                <p class="m-0">
                    <i class="fa-light fa-circle-info icon-primary" style="margin-right: 8px;"></i>
                    Desde aquí podrás bloquear o liberar asientos para cada sesión, si quieres
                    editar el mapa base, contacta con el administrador.
                </p>
            </div>
            <div *ngIf="loadingBlockedSeats || loadingMap"
                class="loading-container-panel map-loading-container w-100 d-flex justify-content-center">
                <div class="container-lottie">
                    <ng-lottie class="lottie" [options]="{path: 'assets/lotties/loading.json'}"
                        containerClass="loading-box"></ng-lottie>
                </div>
            </div>
            <div *ngIf="!loadingBlockedSeats" [hidden]="loadingMap">
                <app-create-map [fromCreate]="true" [fromEvent]="editCreateMap" [idEvent]="idEvent" [idSpace]="venue?.id"
                    [venue]="venue" [idMap]="map?.id" [allowCreate]="!!idEvent"
                    [blockedSeats]="blockedSeats" [selectedSession]="selectedSession"
                    (loadingChange)="onMapLoadingChange($event)"></app-create-map>
            </div>
        </div>

    </ng-template>
</div>
